import { Box } from "@mui/material";
import { Route, Routes, Outlet, Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";
import React, { useContext, useEffect } from 'react';
import Login from '../components/Connexion/Login';
import UnauthorizedPage from '../components/UnauthorizedPage';
import NavBar from '../components/Navigation/NavBar';
import SideBar from '../components/Navigation/SideBar';
import Dashboard from '../components/Dashboard/Dashboard';
import ResetPassword from '../components/Connexion/ResetPassword';
import DisciplineList from '../components/Discipline &Units/DisciplineList';
import SkillsList from '../components/Skills/SkillsList';
import EvaluationList from '../components/Evaluations/EvaluationList';
import EmployeesList from '../components/Employees/EmployeesList';
import PostesList from '../components/Administration/Postes/PostesList';
import RolesList from "../components/Administration/Roles/RolesList";
import AuditLogsPage from "../components/Administration/audit/AuditLogsPage";
import UserCompanyList from "../components/UserCompany/UserCompanyList";
import RaterTypeList from "../components/Administration/RaterType/RaterTypeList";
import MyEvaluation from '../components/ProfileEmployee/MyEvaluation';
import QuizList from '../components/Quiz/QuizList';
import MyCertificates from '../components/ProfileEmployee/MyCertificates';
import EvidencesFileList from '../components/Evaluations/EvidencesFileList';
import Profile from '../components/Navigation/Profile';
import Settings from '../components/Navigation/Settings';
import CompetencyReportsDashboard from '../components/competencyReports/CompetencyReportsDashboard';
import ProtectedRoute from './ProtectedRoute';
import DashboardEmployee from '../components/Dashboard/DashboardEmployee';
import TakeAssignedQuiz from '../components/Quiz_Evaluation/TakeAssignedQuiz';
import DashboardMain from "../components/Dashboard/DashboardMain";


const AppRoutes = () => {

    const {isAuth, isLoading, ability, isEmployee} = useContext(AuthContext);
  
  // Log only authentication state for debugging
  console.log('AppRoutes - Authentication state:', isAuth);

    const canAccess = (resource) => ability?.can?.('read', resource) ?? false;

    // Helper function to create redirect route - with permission check
    const createRedirectRoute = (basePath, routes) => {
        return (
            <Route
                key={`Route.${basePath}.Index`}
                index
                element={
                    <Navigate
                        to={
                            routes.find(path => {
                                const pathParts = path.split('/');
                                const lastPart = pathParts[pathParts.length - 1];

                                // Handle special cases for resource name extraction
                                let resource;
                                if (lastPart === 'list') {
                                    resource = pathParts[pathParts.length - 2].slice(0, -1); // Remove 's' from plural
                                } else if (lastPart.includes('-')) {
                                    resource = lastPart.split('-')[0]; // Take first part before hyphen
                                } else {
                                    resource = lastPart;
                                }

                                // Capitalize first letter and remove trailing 's' if exists
                                resource = resource.charAt(0).toUpperCase() + resource.slice(1).replace(/s$/, '');

                                return canAccess(resource);
                            }) || routes[0] // Fallback to first route if no permissions match
                        }
                        replace
                    />
                }
            />
        );
    };

    // Protected route with ability check
    const AbilityRoute = ({element, resource, fallback = "/dashboard"}) => {
        // Defer rendering until ability is available to avoid false redirects and null errors
        if (!ability) return null;
        return canAccess(resource) ? element : <Navigate to={fallback} replace/>;
    };

  // useEffect(() => {
  //   console.log('AppRoutes - Authentication state changed:', isAuth);
  // }, [isAuth]);

  return (
    <Routes>
      {/* Public routes - accessible when not authenticated */}
      <Route path="/login" element={
        isAuth ? <Navigate to="/dashboard" replace /> : <Login />
      } />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      
      {/* Protected routes - require authentication */}
    <Route path="/" element={
        <ProtectedRoute element={
            <Box sx={{ display: "flex", height: "100vh" }}>
                <SideBar />
                <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
                    <NavBar />
                    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'auto', p: 3 }}>
                        <Outlet />
                    </Box>
                </Box>
            </Box>
        } />
    }>

        {/* Child routes of the protected layout */}
        <Route index element={<Navigate to="/dashboard" replace />} />

        
        {/* Dashboard  Competency Reports - accessible by all authenticated users */}
        <Route path="/dashboard" element={<DashboardMain />} />
        <Route path="profile" element={<Profile />} />
        <Route path="settings" element={<Settings />} />
        

        
        
        {/* Employees Management */}
        {/* <Route path="employees" element={<EmployeesList />} /> */}
        
        {/* Postes Management */}
        {/* <Route path="postes" element={<PostesList />} /> */}
        
        {/* Skill Levels Management */}
        {/* <Route path="skill-levels" element={<SkillLevelList />} /> */}

        {/* My Evaluations */}
        <Route path="my-evaluation" element={<MyEvaluation />} />
        <Route path="quiz/assigned" element={<TakeAssignedQuiz />} />
        {/* <Route path="dashboard-employee" element={<DashboardEmployee />} /> */}



        {/* My Certificates */}
        <Route path="my-certificates" element={<MyCertificates />} />

        <Route key="Route.Admin" path="/admin" element={<ProtectedRoute element={<Outlet/>}/>}>
              <Route key="Route.Departements.Users" path="users" element={<ProtectedRoute
                  element={<AbilityRoute element={<UserCompanyList/>} resource="User"/>}/>}/>
              <Route key="Route.Admin.Roles" path="roles" element={<ProtectedRoute
                  element={<AbilityRoute element={<RolesList/>} resource="Role"/>}/>}/>
              <Route key="Route.Admin.Postes" path="postes" element={<ProtectedRoute
                  element={<AbilityRoute element={<PostesList/>} resource="Poste"/>}/>}/>
            <Route key="Route.Admin.AuditLog" path="audit-logs" element={<ProtectedRoute
                  element={<AbilityRoute element={<AuditLogsPage/>} resource="Poste"/>}/>}/>
              {createRedirectRoute('Admin', ['/admin/users','/admin/roles', '/admin/postes', '/admin/audit-logs' ])}
              <Route key="Route.Admin.RaterType" path="rater-types" element={<ProtectedRoute
                  element={<AbilityRoute element={<RaterTypeList/>} resource="RaterType"/>}/>}/>
                {/* Discipline Management */}
              <Route key="Route.Disciplines" path="disciplines" element={<ProtectedRoute
                  element={<AbilityRoute element={<DisciplineList/>} resource="Discipline"/>}/>}/>
               {/* Skills Management */}
               <Route key="Route.Skills" path="skills" element={<ProtectedRoute
                  element={<AbilityRoute element={<SkillsList/>} resource="Skill"/>}/>}/>
                  {/* Evaluations Management */}
               <Route key="Route.Evaluations" path="evaluations" element={<ProtectedRoute
                  element={<AbilityRoute element={<EvaluationList/>} resource="Evaluation"/>}/>}/>
                  {/* Quizzes Management */}
               <Route key="Route.Quizzes" path="quizzes" element={<ProtectedRoute
                  element={<AbilityRoute element={<QuizList/>} resource="Quiz"/>}/>}/>
                  {/* Certificates Management */}
               <Route key="Route.Certificates" path="certificates" element={<ProtectedRoute
                  element={<AbilityRoute element={<MyCertificates/>} resource="Certificate"/>}/>}/>
               {/* Evidences Management */}
               <Route key="Route.Evidences" path="evidences" element={<ProtectedRoute
                  element={<AbilityRoute element={<EvidencesFileList/>} resource="Evidence"/>}/>}/>
          </Route>
        {/*/Admin routes */}
        <Route path="settings" 
          element={<ProtectedRoute 
            element={<div>Settings Page</div>} 
          />} 
        />
        
        {/* Protected route fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
